import React from 'react'
import cx from 'classnames'
import styles from './ParagraphEl.module.css'

const ParagraphEl = ({ children, color = 'light', extraClasses = [] }) => {
  return (
    <p
      style={{
        // padding: '0px 30px',
        color:
          (color === 'dark' && '#212121') || (color === 'light' && '#ffffff')
      }}
      className={cx(styles.paragraphStyles, ...extraClasses)}
    >
      {children}
    </p>
  )
}

export default ParagraphEl
